import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang, t } from "@/context/LangContext";
import { Calendar, Building2 } from "lucide-react";

const IPO = () => {
  const { lang } = useLang();
  const [ipos, setIpos] = useState([]);
  const [market, setMarket] = useState("all");

  useEffect(() => {
    const q = { params: {} };
    if (market !== "all") q.params.market = market === "id" ? "Indonesia" : "US";
    api.get("/ipos", q).then((r) => setIpos(r.data.ipos || []));
  }, [market]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="ipo-page">
      <div className="overline text-white/40 mb-3">{t(lang, "Kalender IPO", "IPO Calendar")}</div>
      <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter mb-8">
        {t(lang, "Saham IPO Terbaru", "Upcoming & Recent IPOs")}
      </h1>

      <div className="flex border border-white/10 rounded-md overflow-hidden inline-flex mb-8" data-testid="ipo-market-filter">
        {[
          { id: "all", label: "All" },
          { id: "id", label: "Indonesia" },
          { id: "us", label: "USA" },
        ].map((f) => (
          <button
            key={f.id}
            onClick={() => setMarket(f.id)}
            data-testid={`ipo-filter-${f.id}`}
            className={`px-5 py-2 text-sm font-medium transition-colors ${market === f.id ? "bg-white text-black" : "text-white/60 hover:text-white hover:bg-white/5"}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="grid gap-4">
        {ipos.map((ipo) => (
          <div key={ipo.symbol} data-testid={`ipo-${ipo.symbol}`} className="border border-white/10 rounded-2xl p-6 lg:p-8 hover:border-white/20 transition-colors bg-[#0d0d0d]">
            <div className="grid md:grid-cols-12 gap-6 items-start">
              <div className="md:col-span-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className={`overline px-2 py-1 rounded ${ipo.status === "Upcoming" ? "bg-emerald-500/20 text-emerald-400" : "bg-white/10 text-white/70"}`}>
                    {ipo.status}
                  </span>
                  <span className="overline text-white/40">{ipo.market}</span>
                </div>
                <div className="font-display font-black text-2xl md:text-3xl tracking-tight">{ipo.symbol}</div>
                <div className="text-white/70 mt-1">{ipo.name}</div>
                <div className="text-sm text-white/50 mt-3">{ipo.description}</div>
              </div>
              <div className="md:col-span-7 grid grid-cols-2 gap-3">
                <Metric icon={Calendar} label={t(lang, "Tanggal IPO", "IPO Date")} value={ipo.ipo_date} />
                <Metric label={t(lang, "Kisaran Harga", "Price Range")} value={ipo.price_range} />
                <Metric label={t(lang, "Saham Ditawarkan", "Shares Offered")} value={ipo.shares_offered} />
                <Metric icon={Building2} label={t(lang, "Sektor", "Sector")} value={ipo.sector} />
                <div className="col-span-2 border border-white/10 rounded-lg p-3">
                  <div className="overline text-white/40 mb-1">{t(lang, "Underwriter", "Underwriter")}</div>
                  <div className="font-mono text-sm">{ipo.underwriter}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Metric = ({ label, value, icon: Icon }) => (
  <div className="border border-white/10 rounded-lg p-3">
    <div className="overline text-white/40 mb-1 flex items-center gap-1.5">
      {Icon && <Icon size={11} />} {label}
    </div>
    <div className="font-mono text-sm">{value}</div>
  </div>
);

export default IPO;
